import React from 'react';
import Toast from '../component/UI/Toast';
import LoadingSpinner from '../component/UI/LoadingSpinner';
import variables from 'src/style/variable/variables.module.scss';
import { toast } from 'react-toastify';
import { getTranslation } from 'src/i18n/translations';


export default {
  success (message, options = {}) {
    return toast(<Toast type='success' message={message} />, {
      ...options,
      hideProgressBar: true,
      className: 'toast success'
    });
  },
  info (message, options = {}) {
    return toast(<Toast type='info' message={message} />, {
      ...options,
      hideProgressBar: true,
      className: 'toast info'
    });
  },
  warn (message, options = {}) {
    return toast(<Toast type='warn' message={message} />, {
      ...options,
      hideProgressBar: true,
      className: 'toast warn'
    });
  },
  update (id, options = {}) {
    return toast.update(id, options);
  },
  error (message, errCode = 400, options = {}) {
    if (errCode === 401
      && (message !== getTranslation('toast.sessionExpired') &&
      message !== getTranslation('toast.ipRestricted'))) {
      return;
    }
    return toast(<Toast type='error' message={message} />, {
      ...options,
      hideProgressBar: true,
      className: 'toast error'
    });
  },
  // Long-running export: a persistent, page-independent toast with a spinner. Survives
  // navigation (it lives outside the download button), so the user can tell the export is
  // still running vs. the page itself loading. Pair with progressDone/progressFail by toastId.
  progressStart (toastId, message) {
    return toast(
      <Toast message={<span className='toast-progress'><LoadingSpinner size={28} color={variables.primary} /> {message}</span>} />,
      {
        toastId,
        autoClose: false,
        closeOnClick: false,
        draggable: false,
        hideProgressBar: true,
        className: 'toast progress'
      }
    );
  },
  progressDone (toastId, message) {
    return toast.update(toastId, {
      render: <Toast type='success' message={message} />,
      autoClose: 4000,
      closeOnClick: true,
      hideProgressBar: true,
      className: 'toast success'
    });
  },
  progressFail (toastId, message) {
    return toast.update(toastId, {
      render: <Toast type='error' message={message} />,
      autoClose: 5000,
      closeOnClick: true,
      hideProgressBar: true,
      className: 'toast error'
    });
  },
  liveDataNotify (message: any, options: any = {}) {
    if (options.toastId && toast(options.toastId)) {
      return null;
    }
    return toast(<Toast message={message} />, {
      className: 'toast live__data',
      position: toast.POSITION.BOTTOM_LEFT,
      autoClose: false,
      draggable: false,
      hideProgressBar: true,
      closeOnClick: false,
      ...options
    });
  }
};
